import {
  TABLE_ACTION_COMPONENTS,
  TABLE_ACTIONS_TYPE,
  TableActionsCreator
} from '@ublique/components'
import {
  ArrowsHorizontal32,
  Locked32,
  Movement32,
  OrderDetails32,
  Unlocked32
} from '@carbon/icons-react'
import GridDate from '../components/GridDate'
import moment from 'moment'
import { BASE_TIME_FORMAT, statusMap } from '../constants'
import { isEmpty } from 'lodash'
import Status from '../components/Status'

export const serverPagination = {
  pagination: true,
  paginationPageSize: 10,
  cacheBlockSize: 10
}

export const filtering = {
  canSearch: false,
  floatingFilter: true,
  filterParams: {
    applyMiniFilterWhileTyping: true
  }
}

export const refreshHeader = (params) => {
  params.api.deselectAll()
  params.api.purgeServerSideCache()
  setTimeout(() => {
    // Necessary because empty row remains visible at first purge
    params.api.purgeServerSideCache()
  }, 100)
}

export const getFilterModelFromSelection = (selected) => {
  if (!selected?.length) {
    return {}
  }

  const filterBody = {
    filterType: 'set',
    type: 'in',
    values: selected.map((row) => row.id)
  }

  return { id: filterBody }
}

export const styling = {
  resizable: true,
  animateRows: true
}

export const defaultColDef = {
  sortable: false,
  lockPosition: true
}

export const tableActionsConfig = ({
  t,
  uom,
  onPaginationSizeChange,
  onUomChange,
  changeStatus,
  onExamine,
  isEditable
}) => {
  const builder = new TableActionsCreator()

  const defaultOptions = [
    {
      id: 'option-2',
      text: '10',
      value: 10
    },
    {
      id: 'option-3',
      text: '25',
      value: 25
    },
    {
      id: 'option-4',
      text: '50',
      value: 50
    },
    {
      id: 'option-5',
      text: '100',
      value: 100
    },
    {
      id: 'option-all',
      text: t('ALL'),
      value: 10000
    }
  ]

  const uomBtn = {
    id: 'uom-btn',
    type: 'primary',
    icon: ArrowsHorizontal32,
    label: uom === 'value' ? t('ITEMS') : t('VALUE_BTN'),
    action: onUomChange
  }

  const blockBtn = {
    id: 'block-btn',
    type: 'primary',
    icon: Locked32,
    label: t('BLOCK'),
    action: () => changeStatus('BLOCCA'),
    selectionBtn: true,
    disabled: !isEditable
  }

  const unlockBtn = {
    id: 'unlock-btn',
    type: 'primary',
    icon: Unlocked32,
    label: t('UNLOCK'),
    action: () => changeStatus('SBLOCCA'),
    selectionBtn: true,
    disabled: !isEditable
  }

  const examineBtn = {
    id: 'examine-btn',
    type: 'primary',
    icon: OrderDetails32,
    label: t('EXAMINE'),
    action: onExamine,
    selectionBtn: true
  }

  builder.addUbliqueBtn(uomBtn)
  builder.addUbliqueBtn(examineBtn)
  builder.addUbliqueBtn(blockBtn)
  builder.addUbliqueBtn(unlockBtn)
  builder.addUbliqueBtn({
    id: 'rows-btn',
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    componentProps: {
      component: TABLE_ACTION_COMPONENTS.PaginationSizeChooser,
      t: t,
      options: defaultOptions,
      initialValue: 10,
      onChange: onPaginationSizeChange
    }
  })

  return builder.getTableButtons()
}
export const detailTableActionsConfig = ({
  t,
  onPaginationSizeChange,
  pageSize,
  changeStatus,
  isEditable,
  detailSelectedRow
}) => {
  const builder = new TableActionsCreator()

  const blockBtn = {
    id: 'block-btn-detail',
    type: 'primary',
    icon: Locked32,
    label: t('BLOCK'),
    action: () => changeStatus('BLOCCA'),
    disabled: !isEditable
  }

  const unlockBtn = {
    id: 'unlock-btn-detail',
    type: 'primary',
    icon: Unlocked32,
    label: t('UNLOCK'),
    action: () => changeStatus('SBLOCCA'),
    disabled: !isEditable
  }

  const partialUnlockBtn = {
    id: 'partial-unlock-btn-detail',
    type: 'primary',
    icon: Movement32,
    label: t('SBLOCCA_SCOPERTO'),
    action: () => changeStatus('SBLOCCA_SCOPERTO'),
    disabled: !isEditable
  }

  const defaultOptions = [
    {
      id: 'option-1',
      text: '5',
      value: 5
    },
    {
      id: 'option-2',
      text: '10',
      value: 10
    },
    {
      id: 'option-3',
      text: '25',
      value: 25
    },
    {
      id: 'option-4',
      text: '50',
      value: 50
    },
    {
      id: 'option-5',
      text: '100',
      value: 100
    },
    {
      id: 'option-all',
      text: t('ALL'),
      value: 10000
    }
  ]

  if (!isEmpty(detailSelectedRow)) {
    builder.addUbliqueBtn(blockBtn)
    builder.addUbliqueBtn(unlockBtn)
    builder.addUbliqueBtn(partialUnlockBtn)
  }

  builder.addUbliqueBtn({
    id: 'rows-btn',
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    componentProps: {
      component: TABLE_ACTION_COMPONENTS.PaginationSizeChooser,
      t: t,
      options: defaultOptions,
      initialValue: pageSize,
      onChange: onPaginationSizeChange
    }
  })

  return builder.getTableButtons()
}

export const frameworkComponents = { agDateInput: GridDate, status: Status }
export const detailFrameworkComponents = {
  agDateInput: GridDate,
  status: Status
}

export const columnDefs = ({ t, store, uom }) => [
  {
    colId: 'checkboxCol',
    headerName: '',
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressMenu: true,
    suppressColumnsToolPanel: true,
    filter: false,
    sortable: false,
    editable: false,
    resizable: false,
    lockPosition: true,
    pinned: 'left',
    width: 50,
    minWidth: 50
  },
  {
    headerName: t('ENTE_STANZA'),
    field: 'enteStanzaLabel',
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: t(`CATEGORY`),
    field: 'category',
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`SEASON`),
    field: 'season',
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`APC`),
    field: 'apc',
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`EVENT`),
    field: 'eventoLabel',
    filter: 'agTextColumnFilter',
    sortable: true,
    width: 300,
    minWidth: 300,
    tooltipField: 'eventoLabel'
  },
  {
    headerName: t(`EVENT_DATE`),
    field: 'eventoData',
    sortable: true,
    ...renderDateFilter(),
    width: 250,
    minWidth: 250
  },
  {
    headerName: t(`UNLOCKED`),
    field: uom === 'value' ? 'sbloccatoVal' : 'sbloccatoNrart',
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`BLOCKED`),
    field: uom === 'value' ? 'bloccatoVal' : 'bloccatoNrart',
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`STATUS`),
    field: 'stato',
    filter: 'agTextColumnFilter',
    cellRenderer: 'status',
    sortable: true
  }
]
export const detailColumnDefs = ({ t, isEditable }) => [
  {
    colId: 'checkboxCol',
    headerName: '',
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressMenu: true,
    suppressColumnsToolPanel: true,
    filter: false,
    sortable: false,
    editable: false,
    resizable: false,
    lockPosition: true,
    pinned: 'left',
    width: 50,
    minWidth: 50
  },

  {
    headerName: t(`SUBDEPARTMENT`),
    field: 'subdepartment',
    filter: 'agTextColumnFilter',
    flex: 1,
    sortable: true,
    tooltipField: 'subdepartment'
  },
  {
    headerName: t(`ROOM`),
    field: 'room',
    flex: 1,
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`OCCUPANCY`),
    field: 'occupancy',
    flex: 1,
    filter: 'agTextColumnFilter',
    sortable: true
  },
  {
    headerName: t(`AVAILABLEPLACES`),
    field: 'availablePlaces',
    flex: 1,
    filter: 'agNumberColumnFilter',
    sortable: true
  },
  {
    headerName: t(`AVAILABLEITEMS`),
    field: 'availableItems',
    flex: 1,
    filter: 'agNumberColumnFilter',
    sortable: true
  },
  {
    headerName: t(`VALUE`),
    field: 'value',
    filter: 'agTextColumnFilter',
    flex: 1,
    sortable: true
  },
  {
    headerName: t(`STATUS`),
    field: 'status',
    flex: 2,
    filter: 'agTextColumnFilter',
    cellRenderer: 'status',
    sortable: true,
    maxWidth: 200
  }

  // {
  //   headerName: t(`STATUS`),
  //   colId: 'status',
  //   field: 'status',
  //   filter: 'agSetColumnFilter',
  //   editable: isEditable,
  //   cellEditor: 'agSelectCellEditor',
  //   cellEditorParams: ({ value }) => {
  //     return {
  //       values: keys(statusMap)
  //     }
  //   },
  //   flex: 2,
  //   cellStyle: ({ value }) => ({ color: getColorByStatus(value) })
  // }
]

export const renderDateFilter = () => ({
  valueFormatter: ({ value }) => {
    const formatString = BASE_TIME_FORMAT
    const momentDate = moment.utc(value)
    return momentDate._isValid ? momentDate.format(formatString) : '\u2014'
  },
  filter: filterTypesMap.date,
  filterParams: { comparator: dateComparator, applyMiniFilterWhileTyping: true }
})

const filterTypesMap = {
  text: 'agTextColumnFilter',
  number: 'agNumberColumnFilter',
  date: 'agDateColumnFilter'
}

// Used for comparisons (isSame, isBetween, etc.) with other dates provided by a date picker
// moment.utc doesn't seem to work very well in those cases
export const getDateWithoutTimezoneOffset = (date) => {
  const momentDate = moment(date)
  const offset = momentDate._tzm
  return momentDate[offset > 0 ? 'subtract' : 'add'](
    Math.abs(offset),
    'minutes'
  )
}

const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  const cellDate = getDateWithoutTimezoneOffset(cellValue)
  if (cellDate.isSame(filterLocalDateAtMidnight, 'day')) return 0
  if (cellDate.isBefore(filterLocalDateAtMidnight)) return -1
  return 1
}

export const getColorByStatus = (status) => {
  switch (status) {
    case statusMap.SBLOCCATO_TOTALE:
      return '#8db990ff'
    case statusMap.SBLOCCO_PARZIALE:
      return '#fbff00ff'
    case statusMap.SBLOCCATO:
      return '#33c53aff'
    case statusMap.BLOCCATO:
      return '#D32F2F'
    default:
      return 'white'
  }
}
